module.exports = __webpack_public_path__ + "img/FinishGameTalk.afdbec85.gif";